import { Dialog, IconButton } from "@mui/material";
import { FileText, Mail, X } from "lucide-react";
import "../../components/Common/FormModal.css";
import "./EmailTemplateView.css";

const EmailTemplateView = ({ templateBody, open, onOpenChange }) => {
  const handleClose = () => onOpenChange(false);
  const html = templateBody || "";
  const hasContent = Boolean(html && String(html).trim());

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth
      maxWidth="md"
      PaperProps={{ className: "fm-dialog etv-dialog" }}
    >
      <div className="fm-header">
        <span className="fm-header-icon" aria-hidden>
          <Mail size={20} strokeWidth={2} />
        </span>
        <div className="fm-header-copy">
          <h2>Email template preview</h2>
          <p>How this message will appear to recipients.</p>
        </div>
        <IconButton
          className="fm-close"
          onClick={handleClose}
          aria-label="Close"
          size="small"
        >
          <X size={18} strokeWidth={2} />
        </IconButton>
      </div>

      <div className="etv-body">
        <div className="etv-meta">
          <div className="etv-meta-row">
            <span>From</span>
            <strong>Netclues Master Portal</strong>
          </div>
          <div className="etv-meta-row">
            <span>Type</span>
            <strong>HTML email body</strong>
          </div>
        </div>

        <div className={`etv-canvas${hasContent ? "" : " is-empty"}`}>
          {hasContent ? (
            <div
              className="etv-html"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          ) : (
            <div className="etv-empty">
              <FileText size={28} strokeWidth={1.6} aria-hidden />
              <p>No email body content available for this template.</p>
            </div>
          )}
        </div>
      </div>

      <div className="fm-footer">
        <button type="button" className="fm-btn" onClick={handleClose}>
          Close
        </button>
      </div>
    </Dialog>
  );
};

export default EmailTemplateView;
